import React, { useRef, useContext, useState, useEffect } from "react";
import { NavLink } from 'react-router-dom';
import Modal from 'react-modal';
import Draggable from "react-draggable";
import { IdiomaContext } from './context/IdiomaContext';
import { traducciones } from '../data/cardsData';
import "./css/cards.css";
import "./css/cardsButton.css";
import "./css/cvmodal.css";

const initialPositions = {
  home: { x: 0, y: 0 },
  about: { x: 0, y: 0 },
  portfolio: { x: 0, y: 0 },
  cv: { x: 0, y: 0 },
  contact: { x: 0, y: 0 }
};

function Cards() {
  const { idioma } = useContext(IdiomaContext);
  const traduccion = traducciones[idioma];
  const [positions, setPositions] = useState(() => {
    const savedPositions = localStorage.getItem('cardPositions');
    return savedPositions ? JSON.parse(savedPositions) : initialPositions;
  });
  const [zIndexes, setZIndexes] = useState(() => {
    const savedZIndexes = localStorage.getItem('cardZIndexes');
    return savedZIndexes ? JSON.parse(savedZIndexes) : {
      home: 1,
      about: 1,
      portfolio: 1,
      cv: 1,
      contact: 1 
    };
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const homeRef = useRef(null);
  const aboutRef = useRef(null);
  const portfolioRef = useRef(null);
  const cvRef = useRef(null);
  const contactRef = useRef(null);

  useEffect(() => {
    localStorage.setItem('cardPositions', JSON.stringify(positions));
  }, [positions]);

  useEffect(() => {
    localStorage.setItem('cardZIndexes', JSON.stringify(zIndexes));
  }, [zIndexes]);

  const handleStart = (cardName) => {
    setZIndexes(prevZIndexes => {
      const maxZIndex = Math.max(...Object.values(prevZIndexes));
      return {
        ...prevZIndexes,
        [cardName]: maxZIndex + 1
      };
    });
  };

  const handleStop = (cardName, e, data) => {
    setPositions(prevPositions => ({
      ...prevPositions,
      [cardName]: { x: data.x, y: data.y }
    }));
  };

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  useEffect(() => {
    const handleResetPositions = () => {
      setPositions(initialPositions); // Restablecer posiciones a las iniciales
    };

    window.addEventListener('resetCardPositions', handleResetPositions);
    
    return () => {
      window.removeEventListener('resetCardPositions', handleResetPositions); // Limpiar el evento al desmontar
    };
  }, []); // Solo se ejecuta una vez al montar el componente

  return (
    <div className="cards">
      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        className="modal"
        overlayClassName="overlay"
        ariaHideApp={false}
        style={{ zIndex: 9999 }}
      >
        <h2 className="modal__title">{traduccion.download}</h2>
        <div className="buttonContainer">
          <a href="/download/cvEN.pdf" download className="downloadButton">
            {traduccion.downloadEn}
          </a>
          <a href="/download/cvES.pdf" download className="downloadButton">
            {traduccion.downloadEs}
          </a>
        </div>
        <button onClick={closeModal} className="closeButton">{traduccion.close}</button>
      </Modal>

      {/* CARD 1 */}
      <Draggable
        nodeRef={homeRef}
        onStart={() => handleStart('home')}
        onStop={(e, data) => handleStop('home', e, data)}
        position={positions.home}
        handle=".drag-handle"
      >
        <div ref={homeRef} className="dragable__home" style={{ zIndex: zIndexes.home }}>
          <div className="drag-handle">✢</div> {/* Icono de arrastre */}
          <NavLink to="/">
            <div className="cv__container">
              <h3 className="home__title">{traduccion.home}</h3>
            </div>
          </NavLink>
        </div>
      </Draggable>

      {/* CARD 2 */}
      <Draggable
        nodeRef={aboutRef}
        onStart={() => handleStart('about')}
        onStop={(e, data) => handleStop('about', e, data)}
        position={positions.about}
        handle=".drag-handle"
      >
        <div ref={aboutRef} className="dragable__about" style={{ zIndex: zIndexes.about }}>
          <div className="drag-handle">✢</div> {/* Icono de arrastre */}
          <NavLink to="/about">
            <div className="cv__container">
              <h3 className="about__title">{traduccion.about}</h3>
            </div>
          </NavLink>
        </div>
      </Draggable>

      {/* CARD 3 */}
      <Draggable
        nodeRef={portfolioRef}
        onStart={() => handleStart('portfolio')}
        onStop={(e, data) => handleStop('portfolio', e, data)}
        position={positions.portfolio}
        handle=".drag-handle"
      >
        <div ref={portfolioRef} className="dragable__portfolio" style={{ zIndex: zIndexes.portfolio }}>
          <div className="drag-handle">✢</div> {/* Icono de arrastre */}
          <NavLink to="/portfolio">
            <div className="cv__container">
              <h3 className="portfolio__title">{traduccion.portfolio}</h3>
            </div>
          </NavLink>
        </div>
      </Draggable>

      {/* CARD 4 */}
      <Draggable
        nodeRef={cvRef}
        onStart={() => handleStart('cv')}
        onStop={(e, data) => handleStop('cv', e, data)}
        position={positions.cv}
        handle=".drag-handle"
      >
        <div ref={cvRef} className="dragable__cv" style={{ zIndex: zIndexes.cv }}>
          <div className="drag-handle">✢</div>
          <div className="cv__container" onClick={openModal}>
            <h3 className="cv__title">{traduccion.cv}</h3>
          </div>
        </div>
      </Draggable>

      {/* CARD 5 */}
      <Draggable
        nodeRef={contactRef}
        onStart={() => handleStart('contact')}
        onStop={(e, data) => handleStop('contact', e, data)}
        position={positions.contact}
        handle=".drag-handle"
      >
        <div ref={contactRef} className="dragable__contact" style={{ zIndex: zIndexes.contact }}>
          <div className="drag-handle">✢</div> {/* Icono de arrastre */}
          <NavLink to="/contact">
            <div className="cv__container">
              <h3 className="contact__title">{traduccion.contact}</h3>
            </div>
          </NavLink>
        </div>
      </Draggable>
    </div>
  );
}

export default Cards;
